<template>
  <div class="ai-insight-group">
    <h5 v-if="title" class="ai-insight-group-title">
      <i v-if="icon" :class="icon"></i>
      {{ title }}
    </h5>

    <div
        class="action-point"
        v-for="(action, index) in items"
        :key="index"
    >
      <div class="action-number">{{ index + 1 }}</div>

      <div class="action-content">
        <strong>{{ action.title }}</strong>
        <p>{{ action.description }}</p>

        <button
            v-if="action.sourceLabel"
            type="button"
            class="action-source-link"
            @click="$emit('select-source', action)"
        >
          <i :class="action.sourceType === 'action' ? 'fa fa-external-link' : 'fa fa-link'"></i>
          {{ action.sourceLabel }}
        </button>
      </div>
    </div>

    <div v-if="!items.length" class="ai-empty-small">
      {{ emptyText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiInsightList',

  props: {
    title: String,
    icon: String,
    items: Array,
    emptyText: String
  }
};
</script>

<style scoped>
.ai-insight-group {
  flex: 1 1 260px;
  min-width: 0;
}

.ai-insight-group-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 6px;
  color: #111;
  font-size: 12px;
  font-weight: 900;
}

.ai-insight-group-title .fa-check-circle {
  color: #39aa94;
}

.ai-insight-group-title .fa-exclamation-circle {
  color: #f32929;
}

.action-point {
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #e4e4e4;
  padding: 10px 0;
  margin: 0;
}

.action-point:last-child {
  border-bottom: 0;
}

.action-number {
  width: 22px;
  height: 22px;
  min-width: 22px;
  border-radius: 50%;
  background: #5d4bd8;
  color: #fff;
  text-align: center;
  line-height: 22px;
  font-size: 11px;
  font-weight: 900;
  margin-right: 9px;
  margin-top: 1px;
}

.action-content {
  flex: 1;
  min-width: 0;
}

.action-point strong {
  display: block;
  color: #111;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.35;
  margin: 0 0 3px;
}

.action-point p {
  margin: 0;
  color: #555;
  font-size: 12px;
  line-height: 1.4;
}

.action-source-link {
  display: inline-block;
  margin-top: 7px;
  border: 0;
  background: transparent;
  color: #2b7ecb;
  padding: 0;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.2;
  text-align: left;
}

.action-source-link:hover {
  color: #1d5d98;
  text-decoration: underline;
}

.action-source-link i {
  margin-right: 4px;
}

.ai-empty-small {
  padding: 10px;
  color: #777;
  font-size: 12px;
  background: #fff;
  border: 1px dashed #ddd;
  border-radius: 4px;
}
</style>
